import {ContestPickResult, ContestPickType} from "../constants/PickXEnums";

class FlexParlayPayoutCalculator {
    constructor(partialFlexFactor=0.04, fullFlexFactor=0.23) {
       this.partialFlexFactor = partialFlexFactor;
       this.fullFlexFactor = fullFlexFactor;
    }

    adjustedMultipliers(m) {
        return {
            fullMultiplier: m*this.fullFlexFactor,
            partialMultiplier: m*this.partialFlexFactor
        }
    }

    computeMultiplier(O)
    {
        if (O < 0)
            return 1.0 + 100.0 / Math.abs(O);
        if (O > 0)
            return 1.0 + (O / 100.0);
        return 1.0;
    }

    computePayouts(parlay, contests) {
        const isNew = parlay.Id.includes('new');
        const emptyResults = [
            {
                correct: 0,
                total: 0,
                multiplier: 0,
                payout: 0,
            }];

        const total = Object.keys(parlay.ContestsPicks).length;
        let sumMultiplier = 1.0;

        for (const [key, value] of Object.entries(parlay.ContestsPicks)) {
            const contest = contests.find(c => c.Id.toString() === key);
            if (!contest) return emptyResults;
            if (value.Result === ContestPickResult.Cancelled) continue;
            if (value.Pick === ContestPickType.Over) {
                sumMultiplier *= this.computeMultiplier(isNew ? contest.StatsOddsOver : parlay.ContestsPicks[contest.Id].OverOdds);
            } else if (value.Pick === ContestPickType.Under) {
                sumMultiplier *= this.computeMultiplier(isNew ? contest.StatsOddsUnder : parlay.ContestsPicks[contest.Id].UnderOdds);
            }
        }

        const { partialMultiplier, fullMultiplier } = this.adjustedMultipliers(sumMultiplier);
        return [
            {
                correct: total - 1,
                total: total,
                multiplier: partialMultiplier,
                payout: partialMultiplier * parlay.Wager
            },
            {
                correct: total,
                total: total,
                multiplier: fullMultiplier,
                payout: fullMultiplier * parlay.Wager
            }
        ];
    }

    static getWinningProbability(totalWon, totalLost, n) {
        let P = 0;
        if (totalLost > 1)
            P = 0.0;
        else if( totalLost > 0)
            P = 1 / Math.pow(2,n);
        else
            P = ( n+1 )/ Math.pow(2,n);
        return P;
    }

}

export default FlexParlayPayoutCalculator;